import { usePrevious } from "./usePrevious";

export const useHasChanged = <T>(val: T) => {
  const prevVal = usePrevious(val);
  return prevVal !== val;
};
